import { OnSiteSearchModule } from './onsite-search-module';
import { OnSiteSearchModuleConfigurations } from './onsite-search-module-configurations';

/**
 *
 */
export class OnsiteSearchModuleCollection {
  /**
   *
   * @private
   */
  private modules: Array<typeof OnSiteSearchModule>;

  /**
   *
   * @param items
   */
  constructor(items: Array<typeof OnSiteSearchModule> = []) {
    this.modules = items;
  }

  /**
   *
   * @param searchQuery
   * @param moduleConfigurations
   */
  getByQuery(searchQuery: string, moduleConfigurations: OnSiteSearchModuleConfigurations): OnSiteSearchModule | null {
    const matchingModules = this.modules.filter((moduleClass) => moduleClass.canHandle(searchQuery));
    if (matchingModules.length > 0) {
      const modConfig = Object.prototype.hasOwnProperty.call(moduleConfigurations, matchingModules[0].CONFIGIDENTIFIER)
        ? moduleConfigurations[matchingModules[0].CONFIGIDENTIFIER]
        : {};
      // @ts-expect-error the abstract class used as interface
      return new matchingModules[0](searchQuery, modConfig);
    }

    return null;
  }

  get length() {
    return this.modules.length;
  }
}
